import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfigService } from '../../../../../core/services/config.service';

import { EmployeeService } from '../employee.service';

@Component({
  selector: 'itpx-employee-add',
  templateUrl: './employee-add.component.html',
  styleUrls: ['./employee-add.component.css']
})
export class EmployeeAddComponent implements OnInit {

    private fields: any[];
    private cancelRoute: string = '/agora/account-data/employees';
    private isInProgress: boolean = false;

    constructor(
        private service: EmployeeService,
        private configService: ConfigService,
        private router: Router,
        private notificationService: NotificationService
    ) { }

    ngOnInit() {
        this.fields = this.service.getFields();
    }

    private onSaveFinished(employee: any) {
        if(employee.roles && employee.roles.length) {
            let result = [];
            employee.roles.forEach(element => {
                result.push({id: element});
            });

            employee.roles = result;
        }

        employee['domains'] = [];
        if(employee.domain.length) {
            employee['domains'].push({'id': employee.domain[0]});
        }
        delete employee.domain;

        this.add(employee);
    }

    private add(employee: any) {
        this.isInProgress = true;
        this.service.add(employee)
            .subscribe(
                body => {
                    this.isInProgress = false;
                    this.notificationService.success('Successfully added the employee', 'Success');
                    this.router.navigate(['/agora/account-data/employees/']);
                },
                error => this.isInProgress = false
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/add/employee-add.component.ts